<template>
  <PageTitle class="mb-4">Set your password</PageTitle>

  <ResetPasswordForm
    @cancel="$router.push({ name: 'login' })"
  ></ResetPasswordForm>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import ResetPasswordForm from "@/components/ResetPasswordForm.vue";
import PageTitle from "@/components/external/PageTitle.vue";

@Options({
  components: { PageTitle, ResetPasswordForm },
})
export default class ResetPassword extends Vue {}
</script>
